var Dlrt;
(function (Dlrt) {
    class MultiSwitchFilter {
        constructor(switches) {
            this.switches = switches;
        }
        get View() {
            return this.switches;
        }
        get Values() {
            return $.makeArray(this.switches.filter(':checked').map((i, sw) => $(sw).data('value')));
        }
        hasValue() {
            return this.getChecked().length > 0 && this.getUnchecked().length > 0;
        }
        clear() {
            this.getUnchecked().each((i, e) => e.switchery.setPosition(true));
        }
        getChecked() {
            return this.switches.filter(':checked');
        }
        getUnchecked() {
            return this.switches.filter(':not(:checked)');
        }
    }
    Dlrt.MultiSwitchFilter = MultiSwitchFilter;
})(Dlrt || (Dlrt = {}));
$.fn.makeMultiSwitchFilter = function () {
    return new Dlrt.MultiSwitchFilter(this);
};

//# sourceMappingURL=MultiSwitchFilter.js.map
